export default {
    "storeConfig": "cc036f9560a7f2d4756b30e55b6b9d5390dfcba1d446ae61c5911f1a78d3ffe9"
};
